import React from 'react';
import { Button, Upload, message } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
const { Dragger } = Upload;
import startCase from 'lodash.startcase';
import FileLoaderService from '../services/file-loader-service';
import { getFileParameters } from '../services/file-loader-service';
import { parseFile, createFile } from '../utils/file-utils';


const VALID_FILE_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/json',
    'application/vnd.ms-excel',
    'text/csv'
];

const FileUpload = ( props ) => {
    const { auth, fileType, fileParameters, onFileUploaded, onReadFile, onUpdateFile, disabled } = props;

    const handleChange = ( info ) => {
        if ( info?.file?.status === 'error' ) {
            message.error( `${ info.file.name } file upload failed -- ${ info.file.error }` );
        }
    };

    const uploadFile = async ( { file, onError, onSuccess } ) => {
        let parameters = fileParameters;
        if ( !parameters ) {
            parameters = getFileParameters();
        }

        try {
            if ( !VALID_FILE_TYPES.includes( file.type ) ) {
                throw new Error( 'Unsupported File Type' );
            }

            let records;
            let uploadFile = file;

            if ( typeof onReadFile === 'function' ) {
                if ( !records ) {
                    records = await parseFile( file );
                }

                let isCanceled = false;
                const cancel = () => {
                    isCanceled = true;
                };

                await onReadFile( { file, records, cancel } );
                if ( isCanceled ) {
                    throw new Error( 'File upload was cancelled' );
                }
            }

            if ( typeof onUpdateFile === 'function' ) {
                if ( !records ) {
                    records = await parseFile( file );
                }

                let isCanceled = false;
                const cancel = () => {
                    isCanceled = true;
                };

                records = await onUpdateFile( { file, records, cancel } );
                if ( isCanceled ) {
                    throw new Error( 'File upload was cancelled' );
                }

                uploadFile = createFile( records, file.name );
            }

            const fileLoader = FileLoaderService( auth.state );
            const uploadResult = await fileLoader.upload( fileType, uploadFile, parameters );

            onSuccess( uploadResult, uploadFile );

            if ( typeof onFileUploaded === 'function' ) {
                onFileUploaded( uploadResult );
            } else {
                message.success( `${ file.name } file uploaded successfully.` );
            }
        } catch ( error ) {
            console.error( 'Error uploading file', error.status );
            onError( error.message );
        }
    };

    return (
        <div className="file-upload">
            <Dragger
                disabled={ disabled }
                customRequest={ uploadFile }
                onChange={ handleChange }
            >
                <p className="ant-upload-text">
                    <FileAddOutlined className="file-loader-hatch-upload-icon" />
                </p>
                <p className="ant-upload-text">Drag and Drop a <strong>{ startCase( fileType ) }</strong> file here</p>
                <p className="ant-upload-text">or</p>
                <Button type="primary">Select File</Button>
            </Dragger>
            <div className="file-loader-supported-types">
                <span>Supported file types:</span>
                <br />
                <span>CSV, XLS, XLSX</span>
            </div>
        </div>
    );
};

export default FileUpload;